import { useTrackEventEffect } from '@order/Telemetry';

import { useGiftCardOrdersQuery } from '../../graphql/GiftCardOrders.generated';

export const useGiftCardOrders = () => {
  const [{ data, fetching, error }] = useGiftCardOrdersQuery({
    requestPolicy: 'network-only',
  });

  const giftCardOrders = data?.giftCardPurchaseHistory?.giftCardOrders ?? [];

  useTrackEventEffect({
    name: 'gift.history_failure',
    skip: !error,
    payload: {
      userError: error?.message,
      systemError: error,
    },
  });

  return {
    giftCardOrders,
    isFetchingOrders: fetching,
  };
};
